module.exports = __webpack_public_path__ + "img/clock.5c956649.gif";